import axiosInstance from "src/common/axiosInstance";

/* GET /workspaces/{workspaceId}/users */
export async function getWorkspaceUsers(workspaceId) {
  const response = await axiosInstance.get(`/workspaces/${workspaceId}/users`);
  return response.data?.data || [];
}

/* POST /workspaces/{workspaceId}/users */
export async function addWorkspaceUser(workspaceId, payload) {
  const response = await axiosInstance.post(`/workspaces/${workspaceId}/users`, payload);
  return response.data?.data || null;
}

/* PATCH /workspaces/{workspaceId}/users/{workspaceUserId} */
export async function updateWorkspaceUser(workspaceId, workspaceUserId, payload) {
  const response = await axiosInstance.put(
    `/workspaces/${workspaceId}/users/${workspaceUserId}`,
    payload
  );

  return response.data?.data || null;
}

/* DELETE /workspaces/{workspaceId}/users/{workspaceUserId} */
export async function removeWorkspaceUser(workspaceId, workspaceUserId) {
  const response = await axiosInstance.delete(
    `/workspaces/${workspaceId}/users/${workspaceUserId}`
  );
  return response.data;
}

export async function getTeamMemberPerformance(workspaceId, userId, params = {}) {
  const response = await axiosInstance.get(`/workspaces/${workspaceId}/team/${userId}/performance`, { params });
  return response.data?.data || null;
}
